// extracted by mini-css-extract-plugin
export default {"header_element":"header-element_header_element__xGXmH"};